"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getEmailLabels = void 0;
const de_json_1 = __importDefault(require("./de.json"));
const en_AU_json_1 = __importDefault(require("./en-AU.json"));
const en_GB_json_1 = __importDefault(require("./en-GB.json"));
const en_US_json_1 = __importDefault(require("./en-US.json"));
const en_json_1 = __importDefault(require("./en.json"));
const es_json_1 = __importDefault(require("./es.json"));
const fr_json_1 = __importDefault(require("./fr.json"));
const en = en_json_1.default;
const fr = fr_json_1.default;
const es = es_json_1.default;
const de = de_json_1.default;
const enAU = en_AU_json_1.default;
const enGB = en_GB_json_1.default;
const enUS = en_US_json_1.default;
const BASE_LOCALES = { en, fr, es, de };
const OVERRIDES = {
    ["en-au"]: enAU,
    ["en-gb"]: enGB,
    ["en-us"]: enUS,
};
const getEmailLabels = (locale) => {
    const normalized = locale.toLowerCase();
    const [lang] = normalized.split("-");
    const base = BASE_LOCALES[lang] ?? en;
    const override = OVERRIDES[normalized];
    const merged = override ? { ...base, ...override } : base;
    const currentYear = new Date().getFullYear();
    return {
        ...merged,
        footerCopyrightDafOrganization: merged.footerCopyrightDafOrganization.replace("{year}", String(currentYear)),
        footerCopyrightDafReminder: merged.footerCopyrightDafReminder.replace("{year}", String(currentYear)),
        footerCopyrightDaf: merged.footerCopyrightDaf.replace("{year}", String(currentYear)),
        footerCopyright: merged.footerCopyright.replace("{year}", String(currentYear)),
        footerCopyrightParticipation: merged.footerCopyrightParticipation.replace("{year}", String(currentYear)),
        footerCopyrightNewsletterConfirmation: merged.footerCopyrightNewsletterConfirmation.replace("{year}", String(currentYear)),
        footerCopyrightTeamMemberJoined: merged.footerCopyrightTeamMemberJoined.replace("{year}", String(currentYear)),
        footerCopyrightSepaDebitNotice: merged.footerCopyrightSepaDebitNotice.replace("{year}", String(currentYear)),
    };
};
exports.getEmailLabels = getEmailLabels;
